'use client';
/** @jsxImportSource @emotion/react */

import type { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

import MuiTextField from '@mui/material/TextField';

type ExcludedMuiProps = 'autocomplete' | 'color';

type TextareaProps = Omit<MuiTextFieldProps, ExcludedMuiProps>;

const Textarea: React.FC<TextareaProps> = (props) => {
  return <MuiTextField multiline={true} {...props} />;
};

export type { TextareaProps };
export { Textarea };

Textarea.displayName = 'Textarea';
